// extracted by mini-css-extract-plugin
export default {"root":"Table_root__vA1-L","table_heading":"Table_table_heading__Eyo82","row_data":"Table_row_data__XzFLq"};